const SECONDS = 60;
const MIN_MINUTES_QTY = 1;

export const getTimeCost = ({ duration }: { duration: number }) => {
  return Math.max(MIN_MINUTES_QTY, Math.round(duration / SECONDS));
};
